import { useFetchCities } from "../hooks/useFetchCities";
import { useFetchPlaces } from "../hooks/useFetchPlaces";
import { useFetchTags } from "../hooks/useFetchTags";
import { useFetchUser } from "../hooks/useFetchUser";

const GlobalDataProvider = () => {
  useFetchPlaces();
  useFetchTags();
  useFetchCities();
  useFetchUser();

  return null;
};

export default GlobalDataProvider;
